// eslint-disable-next-line no-unused-vars
import $ from 'jquery'; // added here so we don't have to include it everywhere manually
import 'bootstrap/dist/css/bootstrap.min.css'; // we need to use the MiniCssExtractPlugin for webpack instead of style-loader. The latter dynamically loads css after script parsing which means styles arent applied to the page immediately and content will flash before they're loaded
import 'bootstrap/dist/js/bootstrap.bundle'; // requires jQuery to be imported first
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/brands.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import './style.css';